







































































































import Button from '@/types/components/Button.interface'
import Vue from 'vue'
import inputsMixin from '@/mixins/inputs-mixin'
export default Vue.extend({
    mixins: [inputsMixin],
    props: {
        //  The buttons being displayed
        buttons: {
            type: Array,
            required: true
        },
        //  Determines if the control is disabled
        disabled: {
            type: Boolean,
            default: false
        },
        //  Applies the 'small' prop to button
        small: {
            type: Boolean,
            default: false
        },
        //  Determines if the buttons are styled as icons
        icons: {
            type: Boolean,
            default: false
        },
        //  Determines the horizontal alignment of the buttons
        justify: {
            type: String,
            default: 'start'
        },
        //  Determines if we display this as a menu all the time
        min: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            required: false
        }
    },
    computed: {
        //  The buttons displayed in desktop view
        items(): object {
            //  Remove 'hidden' buttons
            return this.buttons.filter((x) => x.hidden !== true)
        },
        //  Reverse the item order for mobile layout
        reversed(): object {
            return this.items.reverse()
        }
    },
    methods: {
        btnColor(button: Button): string {
            //  Check if this button is pseudo disabled
            const disabled = button.disabledPopup

            //  If it is then use the default disabled color
            if (disabled) return 'rgba(0, 0, 0, 0.26)'

            //  Else, return our button color OR primary if color not set
            return button.color || 'primary'
        },
        click(button: Button): void {
            //  Check if our button is disabled pseudo
            const disabled = button.disabledPopup

            //  If it is, then use our disabled popup
            if (disabled) return this.disabledPopup(button)

            //  If a callback is set, it override other options
            if (button.callback) return button.callback(button)

            //  Else, emit click and button
            this.$emit('click', button)
        },
        disabledPopup(button: Button): void {
            //  Open a dialog informing user they cannot
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Button Disabled',
                text: button.disabledPopupText,
                icon: 'mdi-alert',
                color: 'primary',
                closeable: true
            })
        },
        //  Determines if a margin is applied between buttons
        needsMargin(button: Button): boolean {
            //  If the button is an icon, no margin is needed, return false
            if (button.icon && !button.text) return false

            //  If there is more than one button, apply the margin, return true
            if (this.items.length > 1) return true

            //  Else, return default false
            return false
        }
    }
})
